AccountableMixin = require 'mixins/accountable'

App.Account = Account = DS.Model.extend AccountableMixin,
  type: (->
    @constructor.toString().split('.')[1].underscore()
  ).property()

  ###
  # Для проверки типа учетной записи
  ###
  isCourier:        Em.computed.equal('type', 'courier')
  isPartner:        Em.computed.equal('type', 'partner')
  isDispatcher:     Em.computed.equal('type', 'dispatcher')
  isStaffMember:    Em.computed.equal('type', 'staff_member')
  isLogisticsStaff: Em.computed.equal('type', 'logistics_staff')

Account.DISABLED_NOTIFICATIONS = [
  [ 'billing_event',              'faye'  ]
  [ 'billing_event',              'sms'   ]
  [ 'order_courier_confirmed',    'sms'   ]
  [ 'order_courier_confirmed',    'email' ]
  [ 'order_restaurant_confirmed', 'sms'   ]
  [ 'order_restaurant_confirmed', 'email' ]
  [ 'order_cooking_start',        'email' ]

  [ 'negative_rate_received',     'sms'  ]
  [ 'negative_rate_received',     'faye' ]
  [ 'negative_rate_received',     'url' ]

  [ 'billing_event',              'url' ]
  [ 'order_courier_confirmed',    'url' ]
  [ 'order_restaurant_confirmed', 'url' ]
  [ 'order_cooking_start',        'url' ]

  [ 'pos_order_export_error',     'sms'  ]
  [ 'pos_order_export_error',     'faye' ]
  [ 'pos_order_export_error',     'url' ]
]

Account.DEFAULT_NOTIFICATIONS = DEFAULT_NOTIFICATIONS = [
  { event_type: 'order_created',              send_sms: false, send_email: false, send_faye: true, send_url: false },
  { event_type: 'billing_event',              send_sms: false, send_email: false, send_faye: false, send_url: false },
  { event_type: 'order_courier_confirmed',    send_sms: false, send_email: false, send_faye: true, send_url: false },
  { event_type: 'order_restaurant_confirmed', send_sms: false, send_email: false, send_faye: true, send_url: false },
  { event_type: 'order_cooking_start',        send_sms: false, send_email: false, send_faye: true, send_url: false },
]



module.exports = Account
